import { createSafeContext } from "utils/createSafeContext";

export const [AuthModalContext, useAuthModalContext] = createSafeContext(
  "useAuthModalContext must be used within AuthModalProvider",
);